import { useEffect } from "react";
import { useLocation } from "wouter";
import { useLogTraffic } from "@workspace/api-client-react";

const getOrCreateSessionId = () => {
  let sessionId = sessionStorage.getItem("wcs_session_id");
  if (!sessionId) {
    sessionId = Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem("wcs_session_id", sessionId);
  }
  return sessionId;
};

const getUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  const src = params.get("utm_source");
  const med = params.get("utm_medium");
  const cam = params.get("utm_campaign");
  const con = params.get("utm_content");
  const ter = params.get("utm_term");
  if (src) sessionStorage.setItem("wcs_utm_source", src);
  if (med) sessionStorage.setItem("wcs_utm_medium", med);
  if (cam) sessionStorage.setItem("wcs_utm_campaign", cam);
  if (con) sessionStorage.setItem("wcs_utm_content", con);
  if (ter) sessionStorage.setItem("wcs_utm_term", ter);
  return {
    utmSource: sessionStorage.getItem("wcs_utm_source") ?? undefined,
    utmMedium: sessionStorage.getItem("wcs_utm_medium") ?? undefined,
    utmCampaign: sessionStorage.getItem("wcs_utm_campaign") ?? undefined,
    utmContent: sessionStorage.getItem("wcs_utm_content") ?? undefined,
    utmTerm: sessionStorage.getItem("wcs_utm_term") ?? undefined,
  };
};

export function useTrafficLogger() {
  const [location] = useLocation();
  const logTraffic = useLogTraffic();

  useEffect(() => {
    const sessionId = getOrCreateSessionId();
    const utm = getUtmParams();
    logTraffic.mutate({
      data: {
        path: location,
        referrer: document.referrer || null,
        userAgent: navigator.userAgent,
        sessionId,
        ...(utm as Record<string, string | null | undefined>),
      } as Parameters<typeof logTraffic.mutate>[0]["data"],
    });
  }, [location]);
}
